import React, { useLayoutEffect } from 'react';

// Register this standalone route at /calendar/connect for GOOGLE_CALENDAR_REDIRECT_URI.
// No provider request here: the authenticated owner/worker page completes the exchange.
const navigateBrowser = target => window.location.replace(target);
export default function GoogleCalendarCallback({ navigate = navigateBrowser } = {}) {
  useLayoutEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const state = params.get('state');
    // Remove credential-bearing query data before storage access can fail.
    window.history.replaceState(window.history.state, '', '/calendar/connect');
    let owner, worker;
    try { owner = sessionStorage.getItem('xavier-calendar-oauth-admin'); worker = sessionStorage.getItem('xavier-calendar-oauth-installer'); }
    catch { return; }
    const path = state && state === owner ? '/admin' : state && state === worker ? '/installer' : null;
    if (!path) return;
    const fragment = new URLSearchParams({ calendar_oauth: '1', state });
    ['code', 'error'].forEach(key => { if (params.has(key)) fragment.set(key, params.get(key)); });
    // Fragments keep the code out of the next server request and Referer headers.
    navigate(`${path}#${fragment.toString()}`);
  }, [navigate]);
  return <p role="status">Google Calendar · Abra sua conta para concluir / Open your account to finish / Abre tu cuenta para finalizar.</p>;
}
